import { genStyleHooks, mergeToken } from '../../theme/internal';
import { initComponentToken, initInputToken } from './token';
// =============================== OTP ================================
const genOTPStyle = token => {
  const {
    componentCls,
    paddingSM,
    // Dui
    borderRadius // Dui
  } = token;
  const controlHeightXL = 60; // Dui
  const lineHeightXL = 1.2; // Dui
  const fontSizeXL = token.fontSizeHeading1; // Dui
  const paddingBlockXL = Math.ceil((controlHeightXL - fontSizeXL * lineHeightXL) / 2 * 10) / 10 - token.lineWidth; // Dui
  const paddingInlineXL = 2.5; // Dui
  return {
    [`${componentCls}`]: {
      display: 'inline-flex',
      alignItems: 'center',
      flexWrap: 'nowrap',
      columnGap: token.calc(paddingSM).sub(2).equal(),
      // Dui
      '&-rtl': {
        direction: 'rtl'
      },
      [`${componentCls}-input`]: {
        textAlign: 'center',
        paddingInline: token.paddingXXS,
        borderRadius // Dui
      },
      // ================= Size =================
      [`&${componentCls}-sm ${componentCls}-input`]: {
        paddingInline: token.calc(token.paddingXXS).div(2).equal()
      },
      [`&${componentCls}-lg ${componentCls}-input`]: {
        paddingInline: token.paddingXS
      },
      // Dui start
      [`&${componentCls}-xl ${componentCls}-input`]: {
        paddingInline: paddingInlineXL,
        paddingBlock: paddingBlockXL,
        fontSize: fontSizeXL,
        lineHeight: lineHeightXL
      }
      // Dui end
    }
  };
};
// ============================== Export ==============================
export default genStyleHooks(['Input', 'OTP'], token => {
  const inputToken = mergeToken(token, initInputToken(token));
  return [genOTPStyle(inputToken)];
}, initComponentToken);